import { useQuery } from '@tanstack/react-query'
import { getCensusUploadQueue } from '../api/census-enrollment-platform-api-client'
import { CensusUploadQueueRequestDto } from '../api/dto/census-upload-job.dto'

export const CENSUS_UPLOAD_QUEUE_COUNT_QUERY_KEY = 'censusUploadQueueCount'

/**
 * How many uploads the Queue would list for these filters. The section stays
 * hidden when there are none, so this asks for one row and reads the total.
 */
export function useCensusUploadQueueCount({
  filters,
  refreshKey,
}: {
  filters: CensusUploadQueueRequestDto
  refreshKey: boolean
}) {
  return useQuery({
    queryKey: [CENSUS_UPLOAD_QUEUE_COUNT_QUERY_KEY, filters, refreshKey],
    queryFn: async () => {
      const { meta } = await getCensusUploadQueue({
        ...filters,
        page: 1,
        limit: 1,
      })
      return meta.total ?? 0
    },
    refetchOnWindowFocus: false,
  })
}
